import React from "react";

const NoContentAvailable = ({
  title = "No Content Available",
  message = "No content available yet.",
  className = "",
  style = {},
}) => {
  return (
    <div
      className={`no-content-container d-flex flex-column align-items-center justify-content-center text-center py-5 my-4 w-100 ${className}`}
      style={{
        padding: "60px 20px",
        minHeight: "260px",
        ...style,
      }}
    >
      <div className="no-content-icon mb-3" style={{ opacity: 0.85 }}>
        <svg
          width="72"
          height="72"
          viewBox="0 0 64 64"
          fill="none"
          stroke="#2D2D2D"
          strokeWidth="2.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {/* Document sheet with fold */}
          <path d="M20 10H38L48 20V50C48 52.2 46.2 54 44 54H20C17.8 54 16 52.2 16 50V14C16 11.8 17.8 10 20 10Z" />
          <path d="M38 10V20H48" />
          {/* Magnifying glass */}
          <circle cx="34" cy="36" r="8" />
          <line x1="40" y1="42" x2="47" y2="49" strokeWidth="3.2" />
        </svg>
      </div>
      <h3
        className="no-content-title fw-bold mb-2"
        style={{
          color: "#E60023",
          fontSize: "1.5rem",
          fontWeight: 700,
          letterSpacing: "-0.01em",
        }}
      >
        {title}
      </h3>
      <p
        className="no-content-message mb-0"
        style={{
          color: "#222222",
          fontSize: "1.05rem",
          fontWeight: 500,
          maxWidth: "480px",
          lineHeight: "1.5",
        }}
      >
        {message}
      </p>
    </div>
  );
};

export default NoContentAvailable;
